import { Grid as MuiGrid } from '@mui/material';

import { BasetenPageEnum } from '@/routes';

import GridCardWrapper from '../../sections/GridCardWrapper';
import { GridContainer } from '../../styled';
import { ListProps } from '../types';
import Card from './Card';

function Grid({ trainingJobs }: ListProps) {
  return (
    <GridContainer px={4} py={2}>
      <MuiGrid container spacing={3}>
        {trainingJobs.map((trainingJob) => (
          <GridCardWrapper<BasetenPageEnum.TrainingJob>
            linkParams={{
              page: BasetenPageEnum.TrainingJob,
              params: { trainingJobId: trainingJob.id },
            }}
            key={trainingJob.id}
            alwaysVisible={trainingJobs.length < 35}
            containerSx={{
              minHeight: 147,
            }}
          >
            <Card trainingJob={trainingJob} />
          </GridCardWrapper>
        ))}
      </MuiGrid>
    </GridContainer>
  );
}

export default Grid;
